import React from 'react';

import Icon from 'components/Icon/Icon';
import {cutWord} from 'utils/helpers/cutWord';

interface IProps {
  address: string;
  phone: string;
  email: string;
  website: string;
}

export const DesktopContactDetails = (props: IProps) => {
  const {phone, email, address, website} = props;

  return (
    <div className="overview-header__desktop-contact">
      <h4>Contact Details</h4>
      <div className="overview-header__desktop-contact-wrapper">
        {phone && (
          <div className="overview-header__desktop-contact-item">
            <Icon icon="phone" />
            {phone}
          </div>
        )}
        {address && (
          <div className="overview-header__desktop-contact-item">
            <Icon icon="contact-address" />
            {address}
          </div>
        )}
        {email && (
          <div className="overview-header__desktop-contact-item">
            <Icon icon="email" />
            {email}
          </div>
        )}
        {website && (
          <div className="overview-header__desktop-contact-item">
            <Icon icon="web" />
            {cutWord(website, 30)}
          </div>
        )}
      </div>
    </div>
  );
};
